import React from 'react';
import { alarmAPI } from '../../../services/api';
import './AlarmModal.css';

const AlarmModal = ({ alarm, onClose, onMarkAsRead }) => {
  const handleConfirm = async () => {
    if (!alarm.isRead) {
      try {
        await alarmAPI.markAsRead(alarm.id);
        onMarkAsRead(alarm.id);
      } catch (error) {
        console.error('알람 읽음 처리 실패:', error);
      }
    }
    onClose();
  };

  // 날짜 포맷팅
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    const diffMinutes = Math.floor(diff / 60000);
    const diffHours = Math.floor(diff / 3600000);
    const diffDays = Math.floor(diff / 86400000);

    if (diffMinutes < 1) return '방금 전';
    if (diffMinutes < 60) return `${diffMinutes}분 전`;
    if (diffHours < 24) return `${diffHours}시간 전`;
    if (diffDays < 7) return `${diffDays}일 전`;
    
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="alarm-modal-overlay" onClick={onClose}>
      <div className="alarm-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="alarm-modal-header">
          <div className="alarm-modal-header-left">
            <h2 className="alarm-modal-title">새로운 알람</h2>
            {!alarm.isRead && <span className="alarm-modal-badge">NEW</span>}
          </div>
          <button className="alarm-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <div className="alarm-modal-body">
          <div className="alarm-modal-item-title">{alarm.title}</div>
          <div className="alarm-modal-item-content">{alarm.content}</div>
          <div className="alarm-modal-meta">
            <span className="alarm-modal-date">{formatDate(alarm.createdAt)}</span>
          </div>
        </div>

        <div className="alarm-modal-footer">
          <button className="alarm-modal-confirm-button" onClick={handleConfirm}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlarmModal;

